// removed by extract-text-webpack-plugin
module.exports = {"root":"_3wPejaPW94FrF9GT6YxRQm","message":"eQS-RCQsbcMFUWmTI99rs","type-success":"_2u97d8txp7H7e5SpIzfAHl","type-error":"_1hmOgBy7dcUrmKEH4ogRBU","type-warning":"Z6-VLkirxIYmSYRqTxg1H"};


//////////////////
// WEBPACK FOOTER
// ./src/components/root/notification.scss
// module id = 1518
// module chunks = 0